import { isLocalhost } from '../modules/utilities';

const GET_SAVED_ITEMS_URL = '/maa-api/saveditems/v1/list';
const SAVED_ITEMS_COMMUNITIES_URL = '/maa-api/saveditems/v1/communities';
const SAVED_ITEMS_FLOORPLANS_URL = '/maa-api/saveditems/v1/floorplans';

const savedItems = {
  "communities": [
    {
      "Id": "652922",
      "PropertyName": "MAA Midtown Piedmont Park",
      "Neighborhood": "Midtown",
      "Image": "/assets/img/neighborhoods-preview.png",
      "Url": "/texas/austin/maa-quarry-oaks/",
      "Price": 0.0,
      "MoveInDate": "0001-01-01T00:00:00",
      "IsRecent": true,
      "IsSaved": true,
      "IsCompare": true,
    },
    {
      "Id": "002",
      "PropertyName": "MAA Pleasant Hill",
      "Neighborhood": "Duluth",
      "Image": "/assets/img/neighborhoods-preview.png",
      "Url": "/texas/austin/maa-quarry-oaks/",
      "Price": 0.0,
      "MoveInDate": "0001-01-01T00:00:00",
      "IsRecent": true,
      "IsSaved": false,
      "IsCompare": false,
    },
    {
      "Id": "003",
      "PropertyName": "MAA Shiloh",
      "Neighborhood": "Kennesaw",
      "Image": "/assets/img/neighborhoods-preview.png",
      "Url": "/texas/austin/maa-quarry-oaks/",
      "Price": 0.0,
      "MoveInDate": "0001-01-01T00:00:00",
      "IsRecent": true,
      "IsSaved": false,
      "IsCompare": false,
    },
    {
      "Id": "004",
      "PropertyName": "MAA Shiloh",
      "Neighborhood": "Kennesaw",
      "Image": "/assets/img/neighborhoods-preview.png",
      "Url": "/texas/austin/maa-quarry-oaks/",
      "Price": 0.0,
      "MoveInDate": "0001-01-01T00:00:00",
      "IsRecent": true,
      "IsSaved": true,
      "IsCompare": false,
    },
    {
      "Id": "005",
      "PropertyName": "MAA Shiloh",
      "Neighborhood": "Kennesaw",
      "Image": "/assets/img/neighborhoods-preview.png",
      "Url": "/texas/austin/maa-quarry-oaks/",
      "Price": 0.0,
      "MoveInDate": "0001-01-01T00:00:00",
      "IsRecent": true,
      "IsSaved": false,
      "IsCompare": false,
    },
    {
      "Id": "006",
      "PropertyName": "MAA Shiloh",
      "Neighborhood": "Kennesaw",
      "Image": "/assets/img/neighborhoods-preview.png",
      "Url": "/texas/austin/maa-quarry-oaks/",
      "Price": 0.0,
      "MoveInDate": "0001-01-01T00:00:00",
      "IsRecent": true,
      "IsSaved": false,
      "IsCompare": false,
    },
    // {
    //   "Id": "009",
    //   "PropertyName": "MAA River Oaks",
    //   "Neighborhood": "Pleasant Hill",
    //   "Image": "-/media/images/properties/georgia/atlanta/maa-river-oaks/slides/2020/ro-16.jpg",
    //   "Url": "/texas/austin/maa-quarry-oaks/",
    //   "Price": 0.0,
    //   "MoveInDate": "0001-01-01T00:00:00",
    //   "IsRecent": true,
    //   "IsSaved": false,
    //   "IsCompare": false,
    // },
    // {
    //   "Id": "010",
    //   "PropertyName": "MAA Jollyville",
    //   "Neighborhood": "Jollyville",
    //   "Image": "-/media/images/properties/texas/austin/maa-quarry-oaks/slides/2022/1-front-pool.jpg",
    //   "Url": "/texas/austin/maa-quarry-oaks/",
    //   "Price": 0.0,
    //   "MoveInDate": "0001-01-01T00:00:00",
    //   "IsRecent": false,
    //   "IsSaved": true,
    //   "IsCompare": true,
    // },
    // {
    //   "Id": "011",
    //   "PropertyName": "MAA Briarcliff",
    //   "Neighborhood": "Downtown",
    //   "Image": "-/media/images/properties/georgia/atlanta/maa-briarcliff/slides/16-post-briarcliff_model-living-1200x525.jpg",
    //   "Url": "/texas/austin/maa-quarry-oaks/",
    //   "Price": 0.0,
    //   "MoveInDate": "0001-01-01T00:00:00",
    //   "IsRecent": false,
    //   "IsSaved": true,
    //   "IsCompare": false,
    // },
    // {
    //   "Id": "012",
    //   "PropertyName": "MAA Glen",
    //   "Neighborhood": "Downtown",
    //   "Image": "-/media/images/properties/georgia/atlanta/maa-glen/slides/2022-repositioning/mg-2.jpg",
    //   "Url": "/texas/austin/maa-quarry-oaks/",
    //   "Price": 0.0,
    //   "MoveInDate": "0001-01-01T00:00:00",
    //   "IsRecent": false,
    //   "IsSaved": true,
    //   "IsCompare": false,
    // },
    // {
    //   "Id": "013",
    //   "PropertyName": "MAA Midtown",
    //   "Neighborhood": "Downtown",
    //   "Image": "-/media/images/properties/georgia/atlanta/maa-midtown/slides/2021/maa-midtown-pool.jpg",
    //   "Url": "/texas/austin/maa-quarry-oaks/",
    //   "Price": 0.0,
    //   "MoveInDate": "0001-01-01T00:00:00",
    //   "IsRecent": false,
    //   "IsSaved": true,
    //   "IsCompare": false,
    // },
    // {
    //   "Id": "014",
    //   "PropertyName": "MAA Quarry Oaks",
    //   "Neighborhood": "Jollyville",
    //   "Image": "-/media/images/properties/texas/austin/maa-quarry-oaks/slides/2022/1-front-pool.jpg",
    //   "Url": "/texas/austin/maa-quarry-oaks/",
    //   "Price": 0.0,
    //   "MoveInDate": "0001-01-01T00:00:00",
    //   "IsRecent": true,
    //   "IsSaved": true,
    //   "IsCompare": true,
    // },
    // {
    //   "Id": "015",
    //   "PropertyName": "MAA Centennial Park",
    //   "Neighborhood": "Downtown",
    //   "Image": "-/media/images/design-stock-images/home-page/our-difference-module/mmp_maa_outdoor_grill_0094_a.jpg",
    //   "Url": "/texas/austin/maa-quarry-oaks/",
    //   "Price": 0.0,
    //   "MoveInDate": "0001-01-01T00:00:00",
    //   "IsRecent": false,
    //   "IsSaved": false,
    //   "IsCompare": true,
    // },
  ],
  "floorplans": [
    {
      "Id": "f006",
      "FloorplanName": "MAA Shiloh",
      "Neighborhood": "Kennesaw",
      "Image": "/assets/img/neighborhoods-preview.png",
      "Url": "/texas/austin/maa-quarry-oaks/",
      "LeasingInfoUrl": "/pages/leasing-terms.html",
      "Price": 4440.0,
      "MoveInDate": "2023-07-03T00:00:00Z",
      "IsRecent": true,
      "IsSaved": false,
      "IsCompare": false,
      UnitType: "1bed",
      "PropertyMapLink": "https://sightmap.com/share/rkwnok2zvd2?unit_id=1230544",
      Phone: '(803) 592-3653',
    },
    {
      "Id": "f002",
      "FloorplanName": "MAA Pleasant Hill",
      "Neighborhood": "Duluth",
      "Image": "/assets/img/neighborhoods-preview.png",
      "Url": "/texas/austin/maa-quarry-oaks/",
      "LeasingInfoUrl": "/pages/leasing-terms.html",
      "Price": 5660.0,
      "MoveInDate": "2023-01-03T00:00:00Z",
      "IsRecent": true,
      "IsSaved": false,
      "IsCompare": false,
      UnitType: "3bed",
      "PropertyMapLink": "https://sightmap.com/share/rkwnok2zvd2?unit_id=1230544",
      Phone: '(803) 592-3653',
    },
    {
      "Id": "f003",
      "FloorplanName": "MAA Shiloh",
      "Neighborhood": "Kennesaw",
      "Image": "/assets/img/neighborhoods-preview.png",
      "Url": "/texas/austin/maa-quarry-oaks/",
      "LeasingInfoUrl": "/pages/leasing-terms.html",
      "Price": 2340.0,
      "MoveInDate": "2023-07-07T00:00:00Z",
      "IsRecent": true,
      "IsSaved": false,
      "IsCompare": false,
      UnitType: "Studio",
      "PropertyMapLink": "https://sightmap.com/share/rkwnok2zvd2?unit_id=1230544",
      Phone: '(803) 592-3653',
    },
    {
      "Id": "f004",
      "FloorplanName": "MAA Shiloh",
      "Neighborhood": "Kennesaw",
      "Image": "/assets/img/neighborhoods-preview.png",
      "Url": "/texas/austin/maa-quarry-oaks/",
      "LeasingInfoUrl": "/pages/leasing-terms.html",
      "Price": 2110.0,
      "MoveInDate": "2023-17-03T00:00:00Z",
      "IsRecent": true,
      "IsSaved": true,
      "IsCompare": false,
      UnitType: "2bed",
      "PropertyMapLink": "https://sightmap.com/share/rkwnok2zvd2?unit_id=1230544",
      Phone: '(803) 592-3653',
    },
    {
      "Id": "f005",
      "FloorplanName": "MAA Shiloh",
      "Neighborhood": "Kennesaw",
      "Image": "/assets/img/neighborhoods-preview.png",
      "Url": "/texas/austin/maa-quarry-oaks/",
      "LeasingInfoUrl": "/pages/leasing-terms.html",
      "Price": 1900.0,
      "MoveInDate": "2023-07-03T00:00:00Z",
      "IsRecent": true,
      "IsSaved": false,
      "IsCompare": false,
      UnitType: "1bed",
      "PropertyMapLink": "https://sightmap.com/share/rkwnok2zvd2?unit_id=1230544",
      Phone: '(803) 592-3653',
    },
  ],
  "compare": [
    {
      "Id": "006",
      "PropertyName": "MAA Shiloh",
      "Neighborhood": "Kennesaw",
      "Image": "/assets/img/neighborhoods-preview.png",
      "Url": "/texas/austin/maa-quarry-oaks/",
      "Price": 0.0,
      "MoveInDate": "0001-01-01T00:00:00",
      "IsRecent": true,
      "IsSaved": false,
      "IsCompare": false,
      Phone: '(803) 592-3653',
    }
  ],
}

export const getAllSavedItems = async () => {
  if (isLocalhost()) {
    return savedItems;
  }
  return fetch(GET_SAVED_ITEMS_URL)
    .then(response => response.json())
    .then(response => {
      console.log(response);
      if (response.success != true) {
        console.error('API error occurred');
        return {};
      }
      return {
        communities: response.communities,
        floorplans: response.floorplans,
      }
    })
    .catch(error => {
      console.error(error);
      return {};
    });
}

export const removeCommunity = async (id) => {
  return fetch(SAVED_ITEMS_COMMUNITIES_URL + id, {
    method: 'DELETE',
  })
    .then(response => response.json())
    .then((response) => {
      console.log(response);
      if (response.success != true) {
        return console.error('API error occurred');
      }
      const customEvent = new CustomEvent('communitiesUpdated', { bubbles: true });
      document.dispatchEvent(customEvent);
    })
    .catch(console.error);
}

export const removeFloorplan = async (id) => {
  return fetch(SAVED_ITEMS_FLOORPLANS_URL + id, {
    method: 'DELETE',
  })
    .then(response => response.json())
    .then((response) => {
      console.log(response);
      if (response.success != true) {
        return console.error('API error occurred');
      }
      const customEvent = new CustomEvent('floorplansUpdated', { bubbles: true });
      document.dispatchEvent(customEvent);
    })
    .catch(console.error);
}



// WEBPACK FOOTER //
// ./src/js/api/saved-items.js